import React, { useState } from 'react';
import { AlertTriangle, X } from 'lucide-react';
import { Button } from './ui/button';
import { useMaintenance } from '../contexts/MaintenanceContext';
import { toast } from 'sonner';

const MaintenanceBanner = () => {
  const { maintenanceStatus, deactivateMaintenance } = useMaintenance();
  const [loading, setLoading] = useState(false);

  if (!maintenanceStatus.is_active) return null;

  const handleDeactivate = async () => {
    setLoading(true);
    try {
      await deactivateMaintenance();
      toast.success('Mode maintenance désactivé');
    } catch (error) {
      toast.error('Erreur lors de la désactivation');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-amber-500 text-amber-950 px-4 py-2 flex items-center justify-between gap-4">
      <div className="flex items-center gap-2 flex-1">
        <AlertTriangle className="h-4 w-4 flex-shrink-0" />
        <span className="text-sm font-medium">
          Mode maintenance actif - Seuls les administrateurs ont accès
        </span>
      </div>
      <Button
        size="sm"
        variant="outline"
        onClick={handleDeactivate}
        disabled={loading}
        className="bg-amber-950/10 border-amber-950/20 hover:bg-amber-950/20 text-amber-950 flex-shrink-0"
      >
        <X className="h-4 w-4 mr-1" />
        {loading ? 'Désactivation...' : 'Désactiver'}
      </Button>
    </div>
  );
};

export default MaintenanceBanner;
